<template>
  <div>
    <div id="jj_chat_app" ></div>
  </div>
</template>

<script>

import {get_chat} from '@core/components/external/chat.js'

export default{

  props: {entry: Object, settings: Object},
  data () {
    return {
      openChat: false
    }
  },
  methods: {

    setOpenChat () {
      this.openChat = !this.openChat
    },

    insertAnswer (msg) {
      var send = {
        user: this.settings.user,
        data: {
          chat_nr: this.chat_nr,
          msg: msg.msg,
          user: msg.userID,
          view: [msg.userID]
        }
      }

      this.$store.dispatch('set_chat', send)
    },

    sendEMail () {

    },

    getChat () {
      var my_class = this

      window.chat_data = {

        messages: this.messages.messages,

        users: {
          1: { name: this.entry.board.user.username, background: '#BF360C', color: '#fff' },
          2: { name: this.$t('company.name') + ' ' + this.$t('message.service'), background: 'rgb(85, 167, 154)', color: '#fff', avatar: '/assets/img/support.png' },
          3: { name: this.entry.name, background: '#1e70b9', color: '#fff' }
        },

        activeUser: my_class.activeUser,
        legend: [1, 3], // false | all | active | me | array
        onSubmit: function (entry) {
          my_class.insertAnswer(entry)
        },

        update: {
          interval: (1000 * 5),
          callback: function (push) {

          }
        }

      }

      new get_chat(12).get_scripts()
    }

  },
  mounted () {
    var my_class = this

    my_class.activeUser = 3

    if (this.$store.getters.user) { my_class.activeUser = 1 }

    this.chat_nr = this.settings.board + '-' + this.settings.ID

    this.$hit_post({url: 'hitclick/chat/get',
      data: { activeUser: my_class.activeUser, user: this.settings.user, chat_nr: this.chat_nr},
      callback: function (ret) {
        my_class.messages = ret.data[1]
        my_class.getChat()
      }})
  }
}

</script>

<style>
#jj_chat_area .msg_area, #jj_chat_area .insert_area, #jj_chat_area .writing_area, #jj_chat_area .pause_area{
  width: 100% !important;
}
</style>
